<template>
  <div class="auth-password-checker">
    <p class="auth-password-checker__disclaimer">{{ $t("auth.requirements.title") }}</p>
    <div class="flex-column">
      <div class="auth-password-checker__item">
        <img v-if="passwordIncludes('uppercase')" alt="Success Icon" :src="sucessIcon" />
        <img v-else alt="Failure icon" :src="failureIcon" />
        <span class="auth-password-checker__item-label">
          {{ $t("auth.requirements.one_uppercase_character") }}
        </span>
      </div>
      <div class="auth-password-checker__item">
        <img v-if="passwordIncludes('symbol')" alt="Success Icon" :src="sucessIcon" />
        <img v-else alt="Failure icon" :src="failureIcon" />
        <span class="auth-password-checker__item-label">
          {{ $t("auth.requirements.one_special_character") }}
        </span>
      </div>
      <div class="auth-password-checker__item">
        <img v-if="passwordIncludes('number')" alt="Success Icon" :src="sucessIcon" />
        <img v-else alt="Failure icon" :src="failureIcon" />
        <span class="auth-password-checker__item-label">
          {{ $t("auth.requirements.one_number") }}
        </span>
      </div>
      <div class="auth-password-checker__item">
        <img v-if="passwordLengthChecker()" alt="Success Icon" :src="sucessIcon" />
        <img v-else alt="Failure icon" :src="failureIcon" />
        <span class="auth-password-checker__item-label">
          {{ $t("auth.requirements.at_least_8_characters") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed } from "@vue/composition-api";
  import { passwordStrength } from "check-password-strength";
  import failure from "@/assets/icons/failure.svg";
  import success from "@/assets/icons/sucess.svg";

  export default {
    props: {
      value: {
        type: String,
        required: true,
      },
    },

    setup(props, context) {
      const failureIcon = failure;
      const sucessIcon = success;

      const score = computed(() => {
        const hasValue = props.value && props.value.length > 0;

        if (!hasValue) {
          return 0;
        }

        const passwordScore = passwordStrength(props.value);

        context.emit("passwordScore", passwordScore);

        return passwordScore;
      });

      const passwordIncludes = value => {
        if (score.value.contains && score.value.contains.includes(value)) {
          return true;
        }

        return false;
      };

      const passwordLengthChecker = () => {
        if (score.value.length && score.value.length >= 8) {
          return true;
        }

        return false;
      };

      return { score, sucessIcon, failureIcon, passwordIncludes, passwordLengthChecker };
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";
  .auth-password-checker {
    &__disclaimer {
      @include text-subtitle-2();
      color: get-color("headline");
      margin-bottom: 4px;
    }
    &__item {
      display: flex;
      align-items: center;
      &:not(:last-of-type) {
        margin-bottom: 4px;
      }
    }
    &__item-label {
      @include text-caption();
      color: get-color("subtitle");
      margin-left: 10px;
    }
  }
</style>
